// extracted by mini-css-extract-plugin
export var notificationHost = "_cj-0";